import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useSystem from '@hooks/useSystem'

import type { DataStoreItemKeyModel } from '@models/types'

const confirmDelete = (deleteDataStoreItemKey: Function) => {
  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Remove Data Store Item?',
    })
    .then(({ value }) => {
      if (value){
        deleteDataStoreItemKey()
      }
    })
}

type UseSystemPayload = ReturnType<typeof useSystem>

interface DataStoreItemKeyListItemProps {
  callbacks: {
    createOrEditDataStoreItemKey: UseSystemPayload['callbacks']['createOrEditDataStoreItemKey'],
    deleteDataStoreItemKey: () => void,
  },
  dataStoreItemKey: DataStoreItemKeyModel,
}

const DataStoreItemKeyListItem = (props: DataStoreItemKeyListItemProps) => {
  const { callbacks, dataStoreItemKey } = props
  const { createOrEditDataStoreItemKey, deleteDataStoreItemKey } = callbacks

  return (
    <DashboardModuleListItem
      title={dataStoreItemKey.title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {dataStoreItemKey.value}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditDataStoreItemKey(dataStoreItemKey)}
          type="edit"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(deleteDataStoreItemKey)}
          type="delete"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default DataStoreItemKeyListItem
